import { LinkCreationService } from '@sportal365/smp-widget-utils';

// Constants
import { assetsPlaceholder } from '../../../../packages/constants/assetsPlaceholder';
import { NOT_AVAILABLE } from '../../../../packages/constants/notAvailable';
import { TARGET_BLANK, TARGET_SELF } from '../../../../packages/constants/windowTarget';

// Types
import { ICompetitionV2 } from '../../../../packages/types/basketball';
import { IConfigEntityLinks } from '../../../../packages/types';

interface INormalizeCompetitionParams {
  competition?: ICompetitionV2;
  dataEntityLinks?: IConfigEntityLinks | null;
}

export const normalizedCompetitionResponseData = ({ competition, dataEntityLinks }: INormalizeCompetitionParams) => {
  if (!competition) return;

  const linkService = dataEntityLinks && new LinkCreationService(dataEntityLinks);
  const target = dataEntityLinks?.configuration?.newWindow ? TARGET_BLANK : TARGET_SELF;

  const url = linkService?.createEntityUrl(competition?.id ?? '', 'competition', '', competition?.slug) ?? '#';

  return {
    id: competition?.id ?? '',
    title: competition?.name ?? NOT_AVAILABLE,
    logo: competition?.assets?.logo?.url || competition?.country?.assets?.flag?.url || assetsPlaceholder.tournament,
    urlTarget: target,
    url,
  };
};
